<template>

  <el-dialog title="添加管理员" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
      <el-form-item label="用户名" prop="user_name">
        <el-input v-model="form.user_name" placeholder="请输入用户名">
        </el-input>
      </el-form-item>
      <el-form-item label="所属角色" prop="role_id">
        <el-select v-model="form.role_id" :multiple="true">
          <el-option v-for="item in roleList" :value="item.role_id" :key="item.role_id" :label="item.role_name_h1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登录密码" prop="password"><el-input v-model="form.password" placeholder="请输入登录密码" type="password"></el-input></el-form-item>
      <el-form-item label="确认密码" prop="confirm_password"><el-input v-model="form.confirm_password" placeholder="请输入确认密码" type="password"></el-input></el-form-item>
      <el-form-item label="姓名" prop="real_name"><el-input v-model="form.real_name"></el-input></el-form-item>
      <el-form-item label="省市区">
        <el-select @change="provinceChange" v-model="form.province_name" filterable  placeholder="请选择省份">
          <el-option
            v-for="item in province_options"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
        <el-select @change="cityChange" v-model="form.city_name" filterable placeholder="请选择城市" :disabled="lock_city">
          <el-option
            v-for="item in city_options"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
        <el-select @change="regionChange" v-model="form.region_name" filterable placeholder="请选择区域" :disabled="lock_region">
          <el-option
            v-for="item in region_options"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学校名称" prop="school_name"><el-input v-model="form.school_name" placeholder="请输入学校名称"></el-input></el-form-item>
      <el-form-item label="年级" prop="grade_name"><el-input v-model="form.grade_name" placeholder="请输入年级"></el-input></el-form-item>
      <el-form-item label="班级" prop="class_name"><el-input v-model="form.class_name" placeholder="请输入班级"></el-input></el-form-item>
      <div :label-width="formLabelWidth" class="tips">提示：省市区、学校、年级、班级为选填项，只选择省份，为省级账号，选择省份和城市，为市级账号，以此类推</div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AuthApi from '@/api/auth.js';
import VisionApi from '@/api/vision.js';
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,

      /* 城市锁 */
      lock_city:true,
      /* 区域锁 */
      lock_region:true,
      province_options:{},
      city_options:{},
      region_options:{},
      /*form表单对象*/
      form: {
        user_name: '',
        access_id: [],
        school_name:'',
        grade_name:'',
        class_name:'',

      },
      /*form验证*/
      formRules: {
        user_name: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        role_id: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        confirm_password: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        real_name: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  props: ['open', 'roleList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    }
  },
  created() {
    this.getAddressList();
  },
  methods: {

    /* 省市区 */
    getAddressList(){
      let self = this;
      VisionApi.provinceList('',true)
        .then(data => {
          console.log(data)
          self.province_options = data.data.list;
        })
        .catch(error => {

        })
    },
    /* 省 */
    provinceChange(selVal){
      let self = this
      /* 判断锁 */
      if (!self.lock_city){
        self.form.city_name = ''
        self.form.city_id = ''
        self.lock_region = true
        self.form.region_name = ''
        self.form.region_id = ''
      }
      self.lock_city = false
      self.form. province_name = selVal.name
      self.form. province_id = selVal.id
      self.cityList(selVal.id)
    },
    /* 市列表 */
    cityList(id){
      let self = this;
      let Params = {}
      Params.province_id = id
      VisionApi.city_list(Params,true)
        .then(data => {
          self.city_options = data.data.list
        })
        .catch(error =>{

        });
    },
    cityChange(selVal){
      let self = this
      if (!self.lock_region){
        self.form.region_name = ''
        self.form.region_id = ''
      }
      self.lock_region = false
      self.form.city_name = selVal.name
      self.form.city_id = selVal.id
      self.regionList(selVal.id);
    },
    /* 区域 */
    regionList(id){
      let self = this;
      let Params = {}
      Params.region_id = id
      VisionApi.region_list(Params,true)
        .then(data => {
          console.log(data)
          self.region_options = data.data.list
        })
        .catch(error =>{

        });
    },
    regionChange(selVal){
      let self = this
      self.form.region_name = selVal.name
      self.form.region_id = selVal.id
      /* 层级太深，需要手动刷新渲染 */
      self.$forceUpdate();
      console.log(self.form.region_name)
      console.log(self.region_options)
    },
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      VisionApi.userAdd(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/vision/manager/dialog/Add.vue